const { parse } = require("./template-syntax-parser");
module.exports = {
  parse,
};
